export const CLIENTS_INITIAL_VAL = {
    name: '',
    type: 'client',
    url: '',
    thumbnail: null,
}